module.exports = __webpack_public_path__ + "static/media/complaint-contact-icon.edb7e299.svg";